<template>
  <div class="clearfix bshadow0 pbs icon-font">
    <span
      :class="`${name} ${color && 'custom-color'} ${defaultSize && 'custom-size'}`"
      :style="{
        ...(color ? { '--icon-color': color } : {}),
        ...(defaultSize ? { '--icon-size': defaultSize } : {}),
      }">
      <span
        v-for="index in path"
        :key="index">
        <span
          :class="`path${index} ${defaultSize && 'custom-size'}`"
          :style="{
            ...(defaultSize ? { '--icon-size': defaultSize } : {}),
          }" />
      </span>
    </span>
  </div>
</template>

<script>
export default {
  props: ["name", "path", "color", "size"],
  computed: {
    defaultSize() {
      switch (this.size) {
        case "medium":
          return "1rem";
        case "x-lg":
          return "1.125rem";
        case "lg":
          return "1.25rem";
        default:
          return this.size || "1rem";
      }
    },
  },
};
</script>

<style lang="scss">
.custom-color:before {
  color: var(--icon-color) !important;
}

.custom-size:before {
  font-size: var(--icon-size) !important;
}
</style>